/**
 * Map seed English words to OpenMoji unicode codepoints.
 * Lifted from the original src/seed/content.js. Words without a sensible
 * emoji match (e.g. "table") fall back to undefined and the UI shows the
 * word as text only. "table" uses a simple local SVG fallback.
 *
 * License: OpenMoji is CC BY-SA 4.0 — credit visible in the app footer.
 */
export const SEED_IMAGE_CODES: Record<string, string> = {
  // Family — picked for max visual difference at thumbnail size.
  // mother: woman holding baby (clearly maternal vs. plain "woman")
  // father: bearded adult (clearly distinct from "boy")
  // brother: small boy
  // sister: small girl with pigtails
  mother: "1F931", // 🤱 breast feeding
  father: "1F9D4", // 🧔 bearded person
  brother: "1F466", // 👦 boy
  sister: "1F467", // 👧 girl
  teacher: "1F9D1-200D-1F3EB",

  friend: "1F91D",
  book: "1F4D8",
  pen: "1F58A",
  pencil: "270F",
  bag: "1F392",

  table: "TABLE",
  chair: "1FA91",
  door: "1F6AA",
  school: "1F3EB",
  rice: "1F35A",

  bread: "1F35E",
  apple: "1F34E",
  banana: "1F34C",
  milk: "1F95B",
  juice: "1F9C3",

  water: "1F4A7",
  dog: "1F436",
  cat: "1F431",
  bird: "1F426",
  fish: "1F41F",

  happy: "1F642",
  sad: "1F641",
  angry: "1F620",
  tired: "1F634",
  one: "0031-FE0F-20E3",

  two: "0032-FE0F-20E3",
  three: "0033-FE0F-20E3",
  four: "0034-FE0F-20E3",
  five: "0035-FE0F-20E3",
  run: "1F3C3",

  walk: "1F6B6",
  jump: "1F998",
  sleep: "1F6CF",
  drink: "1F964",
  eat: "1F37D",

  read: "1F4D6",
  write: "270D",
  look: "1F440",
  in: "1F4E5",
  on: "2B06",

  under: "2B07",
  I: "1F464",
  you: "1F449",
  my: "1F64B",
  your: "1FAF5",
};

const LOCAL_OPENMOJI_BASE = "/images/openmoji";

export function openmojiUrl(code: string | null | undefined): string | null {
  if (!code) return null;
  return `${LOCAL_OPENMOJI_BASE}/${code.toUpperCase()}.svg`;
}

/** Resolve a seed image URL by english word, or null if no mapping. */
export function seedImageUrl(english: string): string | null {
  const code = SEED_IMAGE_CODES[english] ?? SEED_IMAGE_CODES[english.toLowerCase()];
  return openmojiUrl(code);
}
